import { Navigate, useOutletContext } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import Editors from 'modules/enps/components/Editors'
import type Form from 'modules/enps/store/models/Form'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import BasicInfo from './BasicInfo/index'
import DateFrequency from './DateFrequency'

const Configuration = () => {
  const { form } = useOutletContext<{ form: Form }>()

  const canEdit = form && form.policy.can('editEnpsForm')
  const { navigation } = useNavigation()

  if (!canEdit) return <Navigate to={navigation.engagement.enps.answers.fullPath()} />

  return (
    <ResponsivePage.Body
      showHeader={false}
      actions={{
        primary: [],
      }}
    >
      <Box gap="s48">
        <BasicInfo form={form} />
        <DateFrequency form={form} />
        <Editors form={form} />
      </Box>
    </ResponsivePage.Body>
  )
}

export default Configuration
